import { Option, Schema } from "effect";
import { StationId, WorkspaceId } from "../development-identifiers.ts";
import { StationPath } from "../station-path.ts";

export const CanonicalTestFormat = /* @__PURE__ */ (() => Schema.Literals(["json", "image", "html"]))();
export type CanonicalTestFormat = typeof CanonicalTestFormat.Type;
export const CanonicalTestMatch = /* @__PURE__ */ (() => Schema.Union([
  Schema.Struct({ scope: Schema.Literal("workstation"), stationId: Schema.String }),
  Schema.Struct({ scope: Schema.Literal("space"), stationId: Schema.String, spaceId: Schema.String, selector: Schema.optionalKey(Schema.String) })
]))();
export type CanonicalTestMatch = typeof CanonicalTestMatch.Type;
export const CanonicalTestSelector = /* @__PURE__ */ (() => Schema.Union([Schema.Literal("all"), StationPath]))();
export const CanonicalTestRequest = /* @__PURE__ */ (() => Schema.Struct({
  format: CanonicalTestFormat, stationId: StationId,
  target: Schema.Union([
    Schema.Struct({ scope: Schema.Literal("workstation") }),
    Schema.Struct({ scope: Schema.Literal("space"), workspaceId: WorkspaceId, selector: CanonicalTestSelector })
  ])
}))();
export type CanonicalTestRequest = typeof CanonicalTestRequest.Type;

/** Match only the two raw canonical shapes; each value is decoded at the door. */
export const canonicalTestMatch = (url: URL): Option.Option<CanonicalTestMatch> => {
  const station = /^\/api\/stations\/([^/]*)\/tests\/run$/.exec(url.pathname);
  if (station) return Option.some({ scope: "workstation", stationId: station[1] });
  const space = /^\/api\/stations\/([^/]*)\/spaces\/([^/]*)\/tests\/run(?:\/(.*))?$/.exec(url.pathname);
  return space ? Option.some({ scope: "space", stationId: space[1], spaceId: space[2], ...(space[3] === undefined ? {} : { selector: space[3] }) }) : Option.none();
};
